export const EdgeMode = Object.freeze({
  NONE: 0,
  PUSH_LIMIT_PRE: 1,
  PUSH_LIMIT_POST: 2,
  SECOND_CHANCE: 3,
  CLOSE_CALL: 4
})

export default EdgeMode



// WEBPACK FOOTER //
// ./src/components/roller/edgeMode.js